/**
 * Seed del giorno per la "pista di oggi". Qui, nel layer UI, `new Date()` è LECITO
 * (non siamo nel motore deterministico: la data sceglie QUALE seed, poi il gioco è
 * riproducibile da quel seed). In Sprint 3 il seed del giorno arriverà dal server
 * su fuso Europe/Rome, pattern Sequo — questa è la versione locale del prototipo.
 */

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

export function todayId(): string {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function dailySeed(): string {
  return `wake-daily-${todayId()}`;
}
